import { render } from "./ResourceBill.vue?vue&type=template&id=04fcc8e6&scoped=true&ts=true"
import script from "./ResourceBill.vue?vue&type=script&lang=ts"
export * from "./ResourceBill.vue?vue&type=script&lang=ts"

import "./ResourceBill.vue?vue&type=style&index=0&id=04fcc8e6&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fcc8e6"]])

export default __exports__